'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mortice = require('mortice');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mortice__default = /*#__PURE__*/_interopDefaultLegacy(mortice);

let lock;
function createLock(repoOwner = false) {
  if (lock) {
    return lock;
  }
  const mutex = mortice__default["default"]({ singleProcess: repoOwner });
  lock = {
    readLock: func => {
      return async (...args) => {
        const releaseLock = await mutex.readLock();
        try {
          return await func.apply(null, args);
        } finally {
          releaseLock();
        }
      };
    },
    writeLock: func => {
      return async (...args) => {
        const releaseLock = await mutex.writeLock();
        try {
          return await func.apply(null, args);
        } finally {
          releaseLock();
        }
      };
    }
  };
  return lock;
}

exports.createLock = createLock;
